import React from "react";

const Section = ({ children }) => {
  return <section className=" px-60 max-sm:px-6">{children}</section>;
};

export default Section;
